<template>
  <div class="static-map">
    <img :src="computedUrl" />

    <cta
      :text="$t('storeLocator.page.viewOnMaps')"
      color="redtowhite"
      variant="solid"
      class="static-map__cta"
      @click="goToMaps" />
  </div>
</template>

<script setup>
  const props = defineProps({
    place: Object,
    mapsUrl: String
  })

  const config = useRuntimeConfig()
  const { locale } = useI18n()

  const goToMaps = async () => {
    if (props.mapsUrl) {
      await navigateTo(props.mapsUrl, { external: true, open: { target: '_blank' } })
    } else {
      await navigateTo(`https://www.google.com/maps/place/${computedCoordinates.value}`, { external: true, open: { target: '_blank' } })
    }
  }

  const computedCoordinates = computed(() => {
    if (!props.place?.lat) {
      return '41.895560,12.482618'
    }
    return `${props.place.lat},${props.place.lng}`
  })

  const computedUrl = computed(() => `https://maps.googleapis.com/maps/api/staticmap?center=${computedCoordinates.value}&zoom=13&size=800x800&scale=2&format=jpeg&maptype=roadmap&language=${locale.value}&markers=color:blue%7C${computedCoordinates.value}&map_id=${config.public.MAPS_MAP_ID}&key=${config.public.MAPS_API_KEY}`)
</script>

<style lang="scss" scoped>
  .static-map {
    position: relative;

    @include mq($until:medium) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__cta {
      // position: absolute;
      margin: 20px auto;

      @include mq(medium) {
        position: absolute;
        top: 15px;
        right: 15px;
        margin-top: 0;
      }
    }
  }
</style>
